/** 전화번호 하이픈 자동 추가 */
export function formatContactNumber(value: string | null | undefined): string {
  if (!value) return '';

  const parts = String(value).split('___');
  let numPart = parts[0].replace(/[^0-9]/g, '');
  const suffixPart = parts.length > 1 ? `___${parts[1]}` : '';

  if (numPart.length > 11) numPart = numPart.slice(0, 11);

  let formatted = numPart;

  if (numPart.startsWith('02')) {
    if (numPart.length <= 2) formatted = numPart;
    else if (numPart.length <= 5)
      formatted = `${numPart.substring(0, 2)}-${numPart.substring(2)}`;
    else if (numPart.length <= 9)
      formatted = `${numPart.substring(0, 2)}-${numPart.substring(
        2,
        5
      )}-${numPart.substring(5)}`;
    else
      formatted = `${numPart.substring(0, 2)}-${numPart.substring(
        2,
        6
      )}-${numPart.substring(6)}`;
  } else {
    if (numPart.length <= 3) formatted = numPart;
    else if (numPart.length <= 7)
      formatted = `${numPart.substring(0, 3)}-${numPart.substring(3)}`;
    else if (numPart.length <= 10)
      formatted = `${numPart.substring(0, 3)}-${numPart.substring(
        3,
        6
      )}-${numPart.substring(6)}`;
    else
      formatted = `${numPart.substring(0, 3)}-${numPart.substring(
        3,
        7
      )}-${numPart.substring(7)}`;
  }

  return formatted + suffixPart;
}

/** 사업자등록번호 하이픈 자동 추가 */
export function formatBusinessNumber(value: string): string {
  value = value.replace(/[^0-9]/g, '');

  if (value.length > 3 && value.length <= 5)
    value = value.replace(/(\d{3})(\d{1,2})/, '$1-$2');
  else if (value.length > 5)
    value = value.replace(/(\d{3})(\d{2})(\d{1,5})/, '$1-$2-$3');

  return value;
}

/**
 * 숫자를 천단위 콤마로 포맷
 * @param value 숫자 또는 문자열
 * @param suffix 접미사 (예: '원', '조각')
 * @param defaultValue 값이 없을 때 표시할 기본값
 * @returns 포맷된 문자열 (예: 1,234,567원)
 */
export function formatCurrency(
  value: number | string | null | undefined,
  suffix = '',
  defaultValue = '-'
): string {
  if (value === null || value === undefined || value === '') {
    return defaultValue;
  }
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(num)) return defaultValue;
  return num.toLocaleString('ko-KR') + suffix;
}
